import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import classnames from "../../utils/classnames.js";
import Price from "../Price/Price.js";
import Typography from "../Typography/Typography.js";
import './CarTile.css';/* empty css             */
const CarTilePayment = ({
  value,
  hidden,
  label,
  additions,
  className
}) => {
  const isHidden = !value || hidden;
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-car-tile-payment", className), children: [
    /* @__PURE__ */ jsx(Price, { value, valueColor: "dark-light", className: classnames("perxis-auto-car-tile-payment__payment") }),
    /* @__PURE__ */ jsx(Typography.Text, { children: label }),
    additions == null ? void 0 : additions.map(({ children, ...typographyProps }, index) => {
      const isLink = "href" in typographyProps;
      const resolvedIndex = `${index}-link:${isLink}`;
      const TypographyComponent = isLink ? Typography.Link : Typography.Text;
      return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsx(TypographyComponent, { ...typographyProps, children }),
        " "
      ] }, resolvedIndex);
    })
  ] });
};
export {
  CarTilePayment as default
};
//# sourceMappingURL=CarTIlePayment.js.map
